import { Action } from '@ngrx/store';
import { DxUser } from '@digitaix/types';

export enum AuthActionTypes {
  Login = '[Auth] Login',
  Logout = '[Auth] Logout',
  SignUp = '[Auth] SignUp',
  ResetPassword = '[Auth] ResetPassword',
  LoginWithGoogle = '[Auth] Login With Google',
  LoginWithFacebook = '[Auth] Login With Facebook',
  LoginWithTwitter = '[Auth] Login With Twitter',
  LoginWithGithub = '[Auth] Login With Github',
  ApplyAuthCode = '[Auth] Apply Auth Code',
  LoginSuccessful = '[Auth] Login Successful',
  LoginFailed = '[Auth] Login Failed',
}

export class SendPasswordReset implements Action {
  public static TYPE = '@digitaix/core/authentication/SEND_PASSWORD_RESET';
  public readonly type = SendPasswordReset.TYPE;

  constructor(public password: string, public token: string) {}
}

export class LoginSuccessful implements Action {
  public readonly type = AuthActionTypes.LoginSuccessful;
}

export class LoginFailed implements Action {
  public readonly type = AuthActionTypes.LoginFailed;
}

export class AuthEffectsInit implements Action {
  public static TYPE = '@digitaix/core/authentication/AUTH_EFFECTS_INIT';
  public readonly type = AuthEffectsInit.TYPE;

  constructor() {}
}

export class ApplyAuthCode implements Action {
  public readonly type = AuthActionTypes.ApplyAuthCode;

  constructor(public oobCode: string) {}
}

export class ResetPassword<User = DxUser> implements Action {
  public readonly type = AuthActionTypes.ResetPassword;

  public constructor(public email: string) {}
}

export class Login implements Action {
  public readonly type = AuthActionTypes.Login;

  public constructor(public email: string, public password: string) {}
}

export class LoginWithGoogle implements Action {
  public readonly type = AuthActionTypes.LoginWithGoogle;
}

export class LoginWithFacebook implements Action {
  public readonly type = AuthActionTypes.LoginWithFacebook;
}

export class LoginWithTwitter implements Action {
  public readonly type = AuthActionTypes.LoginWithTwitter;
}

export class LoginWithGithub implements Action {
  public readonly type = AuthActionTypes.LoginWithGithub;
}

export class Logout implements Action {
  public readonly type = AuthActionTypes.Logout;
}

export class SignUp implements Action {
  public readonly type = AuthActionTypes.SignUp;

  public constructor(public email: string, public password: string) {}
}

export type AuthActions = Login | Logout | SignUp | ResetPassword;
